import lottie from "lottie-web";

document.querySelectorAll(".lottie-svg").forEach((container) => {
    const animation = lottie.loadAnimation({
        container: container.querySelector(".lottie-svg__svg"),
        renderer: "svg",
        loop: false,
        autoplay: false,
        path: container.dataset.url,
    });
    animation.addEventListener("DOMLoaded", () => container.querySelector("figure")?.remove());
    const card = container.closest(".media");
    card?.addEventListener("mouseenter", () => {
        animation.loop = true;
        animation.goToAndPlay(0, true);
    });
    card?.addEventListener("mouseleave", () => {
        animation.loop = false;
        animation.stop();
    });
});
